import React, { useState } from "react";
import { Button } from "antd";
import { useSelector } from "react-redux";
import ExportExcelIconSmall from "../icons/export/excel/small";
import ExcelExportModal from "./ExcelExportModal";
import { logEvent } from "../../../utils/logger";
import { ButtonContainer } from "./styles";

/**
 * How to use:
 import ExcelExportButton from "../../components/utils/excelExportButton";

 // Uso básico
<ExcelExportButton
  reportName="myReport"
  fileName="exportacao"
/>

// Com colunas e filtros
<ExcelExportButton
  columns={{
    id: "ID",
    name: "Nome",
    value: "Valor"
  }}
  filters={[
    {
      field: "name",
      label: "Nome",
      type: "String",
      operator: "LIKE",
      value: null
    },
    {
      field: "date",
      label: "Data",
      type: "date",
      operator: "BETWEEN",
      value: null
    }
  ]}
  reportName="myReport"
  fileName="exportacao"
  size="large"
/>
 */

const ExcelExportButton = ({
  columns = null,
  filters = null,
  defaultFilters = null,
  reportName,
  fileName,
  style,
  size,
  disabled,
}) => {
  const { translation } = useSelector((state) => state.app);
  const [modalVisible, setModalVisible] = useState(false);

  const handleClick = () => {
    logEvent("ExcelExportButton clicked", { reportName, fileName }, "info");
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  return (
    <>
      <ButtonContainer>
        <Button
          type="primary"
          size={size || "default"}
          disabled={disabled}
          style={{
            backgroundColor: "#199d58",
            borderColor: "#199d58",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            ...style,
          }}
          onClick={handleClick}
        >
          <ExportExcelIconSmall />
          <span>{translation.excelExport?.buttonText || "Exportar"}</span>
        </Button>
      </ButtonContainer>
      <ExcelExportModal
        visible={modalVisible}
        onClose={handleCloseModal}
        columns={columns}
        filters={filters}
        defaultFilters={defaultFilters}
        reportName={reportName}
        fileName={fileName}
      />
    </>
  );
};

export default ExcelExportButton;
